import React from "react";
import CONSTANTS from "../../constants/constants.json";
import "./styles/footer.css";

const { SITE_META, FOOTER_LINKS } = CONSTANTS;

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p className="footer-copy">
        &copy; {new Date().getFullYear()} {SITE_META.COPYRIGHT}
      </p>
      <div className="footer-icons">
        {FOOTER_LINKS.map((link) => (
          <a
            key={link.label}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-icon"
            aria-label={link.label}
            title={link.label}
          >
            <i className={link.icon}></i>
          </a>
        ))}
      </div>
    </footer>
  );
};

export default Footer;
